import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { closeCheckout } from '../actions'
import { ApplePaylaterFlowType } from '../../flow/apple-paylater/model'

export interface ApplePayEntryData {
  sessionIdentifier: string | null
  verifier: string | null
  flowType: ApplePaylaterFlowType
  isValid: boolean
  integration?: string
}

export interface ApplePaylaterInitialState {
  entryData?: ApplePayEntryData
  userHasApplePaylaterCard?: boolean
  userHasInstoreCard?: boolean
}

export const applePaylaterInitialState: ApplePaylaterInitialState = {}

const applePayIntegrationSlice = createSlice({
  name: 'applePaylater',
  initialState: applePaylaterInitialState,
  reducers: {
    setApplePayEntryData(state: ApplePaylaterInitialState, action: PayloadAction<ApplePayEntryData>) {
      state.entryData = action.payload
    },
    clearApplePayEntryData(state: ApplePaylaterInitialState) {
      state.entryData = undefined
    },
    setUserHasApplePaylaterCard(state: ApplePaylaterInitialState, action: PayloadAction<boolean>) {
      state.userHasApplePaylaterCard = action.payload
    },
    setUserHasInstoreCard(state: ApplePaylaterInitialState, action: PayloadAction<boolean>) {
      state.userHasInstoreCard = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(closeCheckout, () => applePaylaterInitialState).addCase(PURGE, () => applePaylaterInitialState)
  },
})

export const { setApplePayEntryData, clearApplePayEntryData, setUserHasApplePaylaterCard, setUserHasInstoreCard } = applePayIntegrationSlice.actions
export default applePayIntegrationSlice.reducer
